<template>
  <div>
    <div v-if="currentUser">
      <div class="site-container" :class="[state.isMobileMenuShowing ? 'sidebar-open' : '']">
        <div :class="[state.isMobileMenuShowing ? 'overlay' : '']">
          <div :class="[state.isMobileMenuShowing ? 'aside-wrapper' : 'aside-wrapper none']">
            <Aside @closeSidebar="closeSidebar" />
          </div>
        </div>
        <div class="router-slot">
          <Navbar @toggleSidebar="toggleSidebar" />
          <div class="warning-container" v-if="!isProduction">
            <h5 class="text-warning">คุณกำลังทำงานอยู่บน {{environment}}</h5>
          </div>
          <transition name="fade">
            <router-view @closeSidebar="closeSidebar"/>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Aside from '@/components/Aside.vue';
import Navbar from '@/components/Navbar.vue';

export default {
  components: {
    Aside,
    Navbar,
  },
  name: 'App',
  data() {
    return {
      state: {
        isMobileMenuShowing: false,
      },
    };
  },
  computed: {
    ...mapGetters(['currentUser', 'environment']),
    isProduction() {
      if (this.environment) {
        return this.environment === 'production';
      }
      return true;
    },
  },
  watch: {
    currentUser() {
      if (!this.currentUser) this.$router.push('/login');
    },
    state: {
      handler(currentState) {
        if (currentState.isMobileMenuShowing === true) {
          document.body.classList.add('sidebar-open');
        } else {
          document.body.classList.remove('sidebar-open');
        }
      },
      deep: true,
    },
  },
  methods: {
    toggleSidebar() {
      this.state.isMobileMenuShowing = !this.state.isMobileMenuShowing;
    },
    closeSidebar() {
      this.state.isMobileMenuShowing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';

.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .25s;
}

.fade-enter-active {
  transition-delay: .25s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}

.overlay {
  background: rgba(0, 0, 0, 0.3);
  position: fixed;
  z-index: 2000;
  top: 0;
  left: 0;
  bottom: 0;
}

.warning-container {
  height: 40px;
  padding: $spacer / 2 0;
  background-color: $yellow;
  text-align: center;
  .text-warning {
    color: white !important;
    font-weight: normal;
  }
}

.site-container {
  display: flex;

  .aside-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 240px;
    background-color: $gray-100;
  }

  .router-slot {
    // flex: 1 0 auto;
    flex: 1;
    min-width: 0;
    margin-left: 240px;
  }
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 991.98px) {
  .site-container {
    flex-direction: column;

    .aside-wrapper {
      z-index: 200;
      box-shadow: 0 1rem 1rem rgba(0, 0, 0, 0.15) !important;
    }

    .router-slot {
      flex: 1 0 100%;
      margin-left: 0;
    }
  }
  .none {
    display: none;
  }
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) and (max-width: 767.98px) {
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) and (max-width: 991.98px) {
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) and (max-width: 1199.98px) {
}

// Extra large devices (large desktops, 1200px and up)
@media (min-width: 1200px) {
}
</style>
